import { defineRouting } from 'next-intl/routing';

import { createNavigation } from 'next-intl/navigation';

export const locales = ['ar', 'en'] as const;
export const localePrefix = 'always'; // Default

export const routing = defineRouting({
  locales,
  defaultLocale: 'ar',
  localePrefix,
});
